module.exports = __webpack_public_path__ + "img/logo.bacbe3fa.png";